/**
 * The salon's time slots and buffer: Settings › Booking window (G51; mpgadmin
 * G238; Lena, 2 Nov 2026: "at the moment default to 15min slot, now we want to
 * give options to admin to choose other slots range … and also add the buffer
 * time setting"). The slot is how far apart the start times are, counted from
 * opening; the buffer is kept clear after every booking. The API refuses a
 * client's booking or reschedule that doesn't keep the buffer, whatever this
 * site shows; this is so the site offers only times it will take.
 *
 * Until the public company carries them (the API's release, and the CMS
 * passing them on), the site keeps today's rule: every 15 minutes, no buffer.
 */

/** Today's step, until the salon's own reaches the booking site. */
export const FALLBACK_SLOT_MINUTES = 15;

/** No buffer, as before it was a setting. */
export const FALLBACK_BUFFER_MINUTES = 0;

/** A slot the API can hold: 5 to 240 minutes, in steps of 5. */
const isSlot = (m: unknown): m is number =>
  typeof m === 'number' && Number.isInteger(m) && m >= 5 && m <= 240 && m % 5 === 0;

/** The salon's slot from the public company, or null when it isn't there yet. */
export const slotOf = (company: any): number | null => {
  const m = company?.clientBookingSlotMinutes;
  return isSlot(m) ? m : null;
};

/** The salon's buffer from the public company, or null when it isn't there yet. 0 is "none". */
export const bufferOf = (company: any): number | null => {
  const m = company?.clientBookingBufferMinutes;
  return typeof m === 'number' && Number.isInteger(m) && m >= 0 && m <= 60 ? m : null;
};
